<template>
  <a-modal
    wrapClassName="customModal"
    v-model="showDialog"
    :title="title"
    centered
    :width="660"
    destroyOnClose
    :maskClosable="false"
    @ok="confirmChoose"
    @cancel="afterClose"
  >
    <div class="dialog-body">
      <a-form-model ref="ruleFormRef" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item ref="name" :label="currentLabel" prop="name">
          <a-input v-model="currentName" />
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>

<script>
export default {
  props: {
    showDialogProp: {
      type: Boolean,
      default: false
    },
    // title: {
    //     type: String
    // },
    name: {
      type: String,
      default: ''
    },
    currentKey: {
      type: Number
    }
  },
  watch: {
    showDialogProp(val, old) {
      this.showDialog = val
      if (val == true) {
        this.currentName = JSON.parse(JSON.stringify(this.name))
        console.log('this.currentName🔧:>>>>>>>', this.currentName, 'addOrEditDialog.vue')
      }
    }
  },
  computed: {
    form: function () {
      let form = {}
      if (this.name) {
        form.name = this.name
      } else {
        form.name = ''
      }
      return form
    },
    title: function () {
      switch (this.currentKey) {
        case 1:
          this.currentLabel = '校区名称'
          this.form.name = ''
          this.currentName = ''
          return '新增校区'
          break
        case 2:
          this.currentLabel = '校区名称'
          return '编辑校区'
          break
        case 3:
          this.currentLabel = '教学楼名称'
          this.form.name = ''
          this.currentName = ''
          return '新增教学楼'
          break
        case 4:
          this.currentLabel = '教学楼名称'
          return '编辑教学楼'
          break
      }
    }
  },
  data() {
    return {
      showDialog: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      rules: {
        // name: [
        //   { required: true, message: '请输入名称', trigger: 'blur' }
        //   // { min: 3, max: 5, message: 'Length should be 3 to 5', trigger: 'blur' },
        // ]
      },
      currentLabel: '校区名称',
      currentName: ''
    }
  },
  methods: {
    afterClose() {
      this.$emit('update:showDialogProp', false)
    },
    confirmChoose() {
      console.log('this.form.name🔧:>>>>>>>', this.form.name, this.currentName, this.name, 'addOrEditDialog.vue')
      if (this.currentName) {
        this.$emit('handleSave', this.currentName)
      } else {
        this.$message.warning('名称不能为空')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .ant-modal-body {
  padding: 24px 16px;
  min-height: 200px;
  border-bottom: 1px solid #e7e7e7;
}
::v-deep .ant-modal-footer {
  padding: 20px;
  border-top: none;
  text-align: center;
  .ant-btn {
    width: 108px;
    height: 38px;
    border: 1px solid #5f60d3;
    color: #5f60d3;
  }
  .ant-btn-primary {
    margin-left: 16px;
    background: #5f60d3;
    color: #fff;
  }
}
</style>
